import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    buttons: {
        textAlign: 'right'
    }
});

const MobileEraseStationForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="HardwareID"
                                value={values.HardwareID}
                                disabled={true}
                                placeholder={translations['hardware_id'] || 'HardwareID'}
                                label={translations['hardware_id'] || 'HardwareID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="RemoteID"
                                value={values.RemoteID}
                                disabled={true}
                                placeholder={translations['remote_id'] || 'Remote ID'}
                                label={translations['remote_id'] || 'Remote ID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="RemotePassword"
                                value={values.RemotePassword}
                                disabled={true}
                                placeholder={translations['remote_password'] || 'Remote password'}
                                label={translations['remote_password'] || 'Remote password'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LicenseName"
                                value={values.LicenseName}
                                disabled={true}
                                placeholder={translations['license_name'] || 'License Name'}
                                label={translations['license_name'] || 'License Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ExpiresAt"
                                value={values.ExpiresAt}
                                disabled={true}
                                placeholder={translations['license_expires_at'] || 'License Expires at'}
                                label={translations['license_expires_at'] || 'License Expires at'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LicenseStatus"
                                value={values.LicenseStatus}
                                disabled={true}
                                placeholder={translations['license_status'] || 'License Status'}
                                label={translations['license_status'] || 'License Status'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={!(isValid && dirty)}
                                    >
                                        {formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(MobileEraseStationForm);
